import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import ArticleCard from "@/components/ArticleCard";
import { SEO, BreadcrumbSchema } from "@/components/SEO";
import api from "@/lib/api";

export default function CategoryPage() {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [articles, setArticles] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/categories/${slug}`).then(async (catRes) => {
      setCategory(catRes.data);
      const artRes = await api.get("/articles", { params: { category: catRes.data.id, page, limit: 9 } });
      setArticles(artRes.data.articles);
      setPages(artRes.data.pages);
    }).catch(console.error).finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [slug, page]);

  if (loading) return <div className="max-w-7xl mx-auto px-6 md:px-12 py-20"><div className="animate-pulse h-96 bg-muted" /></div>;
  if (!category) return <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 text-center"><h1 className="font-heading text-4xl">Catégorie non trouvée</h1></div>;

  return (
    <>
      <SEO title={category.name} description={category.description || `Articles sur ${category.name} — OFALycée`} url={`/categorie/${slug}`} />
      <BreadcrumbSchema items={[{ name: "Accueil", url: "/" }, { name: "Nos Themes" }, { name: category.name }]} />
      <div data-testid="category-page">
        <section className="relative h-64 md:h-80 overflow-hidden">
          {category.image && <img src={category.image} alt={category.name} className="w-full h-full object-cover" />}
          <div className="absolute inset-0 bg-navy-800/60" />
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-6 md:px-12 w-full">
              <span className="text-sm font-mono tracking-widest uppercase text-white/60 mb-2 block">Rubrique</span>
              <h1 className="font-heading text-3xl md:text-5xl text-white" data-testid="category-title">{category.name}</h1>
              <p className="text-white/70 mt-4 max-w-xl">{category.description}</p>
            </div>
          </div>
        </section>
        <section className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          {articles.length === 0 ? (
            <p className="text-center text-muted-foreground text-lg py-12">Aucun article dans cette catégorie.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16">
              {articles.map((a) => <ArticleCard key={a.id} article={a} />)}
            </div>
          )}
          {pages > 1 && (
            <div className="flex justify-center gap-2 mt-16">
              {Array.from({ length: pages }, (_, i) => i + 1).map((p) => (
                <Button key={p} variant={p === page ? "default" : "outline"} className="rounded-none w-10 h-10" onClick={() => setPage(p)}>{p}</Button>
              ))}
            </div>
          )}
        </section>
      </div>
    </>
  );
}
